import type { ChatEntryWithSubTables } from "../../../shared/aiSdkMessages";
import { useWorkflowChangeReviewData } from "../../hooks/useWorkflowChangeReview";
import { PublishedChangeReview } from "./PublishedChangeReview";

export function WorkflowChangeReview({
  version,
  entries,
  onShowDiscussion,
}: {
  version: { commitId: string; workflowId: string; draft?: boolean };
  entries: readonly ChatEntryWithSubTables[];
  onShowDiscussion: (entryId: string) => void;
}) {
  const { review } = useWorkflowChangeReviewData(version.commitId);
  if (!review) return null;
  return (
    <PublishedChangeReview
      key={review.id}
      review={review}
      entries={entries}
      onShowDiscussion={onShowDiscussion}
      draft={version.draft}
    />
  );
}
